import { Box, Button, TextField, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { useState } from "react";
import AxiosT from "../../../../setup/setup-axios-bearer";
import LoadingSpinner from "../../../global/loading-spinner";
import { useGetConfilictInfo } from "../../../../hooks/into-warehouse/useGetConfilictInfo";

const ConfilictUpdate = ({ id, closeModal }) => {
  const [confilictCount, setconfilictCount] = useState();
  const [confilictDesc, setconfilictDesc] = useState();
  const values = useGetConfilictInfo(id);
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(
    ({ conflict_count, conflict_desc }) =>
      AxiosT.post(`/conflict-update/${id}`, {
        conflict_count,
        conflict_desc,
      }),
    {
      onSuccess: (data) => {
        toast.success("ویرایش اطلاعات مغایرت با موفقیت انجام شد");
        closeModal(false);
        queryClient.resetQueries(["getBuyFactordetail"]);
      },
    }
  );

  const handleSubmit = () => {
    mutate({
      conflict_count: confilictCount,
      conflict_desc: confilictDesc,
    });
  };
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Box textAlign="center">
          <TextField
            onChange={(e) => setconfilictCount(e.target.value)}
            label="تعداد کالا"
            fullWidth
            margin="normal"
            name={confilictCount}
            value={confilictCount}
            defaultValue={values?.data?.result.count}
          />
          <TextField
            defaultValue={values?.data?.result.description}
            onChange={(e) => setconfilictDesc(e.target.value)}
            label="توضیحات"
            fullWidth
            margin="normal"
            name={confilictDesc}
          />
          <Box mt={2}>
            <Button
              type="submit"
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading}
              style={{ minWidth: "110px" }}
            >
              ویرایش
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};
export default ConfilictUpdate;
